import React from 'react';
import { secondary } from '../../assets/strings/variables';
import { dataTestimoni } from '../../pages/Homepage/homepageData';
import Carousel from 'react-multi-carousel';
import Quote from '../../assets/icons/Quote';

function Testimoni() {
  const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024,
      },
      items: 3,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0,
      },
      items: 1,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464,
      },
      items: 2,
      partialVisibilityGutter: 30,
    },
  };

  return (
    <section
      id='our-Testimoni'
      className='h-full grid grid-cols-1 max-w-[1200px] m-auto'
    >
      <div className='text-[32px] text-center font-semibold mb-9'>
        Testimoni Klien
      </div>
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlay
        autoPlaySpeed={3000}
        centerMode={false}
        className=''
        containerClass='container-with-dots'
        dotListClass=''
        draggable
        focusOnSelect={false}
        itemClass=''
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={{
          desktop: {
            breakpoint: {
              max: 3000,
              min: 1024,
            },
            items: 3,
            partialVisibilityGutter: 40,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 0,
            },
            items: 1,
            partialVisibilityGutter: 30,
          },
          tablet: {
            breakpoint: {
              max: 1024,
              min: 464,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={true}
        sliderClass=''
        slidesToSlide={1}
      >
        {dataTestimoni.map(({ name, from, testimoni, picture }, idx) => (
          <div
            className={`bg-[#F7F7F7] rounded-lg p-6 mx-1`}
            key={`value-${idx}`}
          >
            <div>
              <div className='text-[#898989]'>
                <Quote />
              </div>
              <div className='text-sm mt-5'>{`"${testimoni}"`}</div>
              <div className='flex mt-5 gap-4 items-center'>
                <img
                  className='w-[48px] h-[48px] rounded-full'
                  src={picture}
                  alt={name}
                />
                <div>
                  <p className='text-sm font-semibold'>{name}</p>
                  <p className='text-xs mt-1 text-[#898989]'>{from}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
}

export default Testimoni;
